import { Component, Inject } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface PromptDialogData {
    title: string;
    message: string;
    placeholder: string;
}

@Component({
    selector: 'app-prompt-dialog',
    templateUrl: './prompt-dialog.component.html',
    styleUrls: ['./prompt-dialog.component.scss']
})
export class PromptDialogComponent {
    public inputControl = new FormControl('', [Validators.required]);

    constructor(
        public dialogRef: MatDialogRef<PromptDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: PromptDialogData
    ) { }

    onCancel(): void {
        this.dialogRef.close(null);
    }

    onConfirm(): void {
        if (this.inputControl.valid) {
            this.dialogRef.close(this.inputControl.value);
        }
    }

    onKeyDown(event: KeyboardEvent): void {
        if (event.key === 'Enter' && this.inputControl.valid) {
            this.onConfirm();
        } else if (event.key === 'Escape') {
            this.onCancel();
        }
    }
}